interface AutomaticSoundOptions {
  createContext: () => AudioContext;
  loadAudio: () => Promise<ArrayBuffer>;
}

/** Unlocks silently during a normal gesture; audio starts only for a real alert. */
export function createAutomaticElectionSound(options: AutomaticSoundOptions) {
  let context: AudioContext | null = null;
  let buffer: Promise<AudioBuffer> | null = null;
  let source: AudioBufferSourceNode | null = null;
  let disposed = false;
  return {
    unlock() {
      if (disposed) return;
      try {
        context ??= options.createContext();
        if (context.state !== 'running') void context.resume().catch(() => {});
      } catch { /* The visual alert also works on devices without Web Audio. */ }
    },
    async play() {
      if (disposed || !context || context.state !== 'running') throw new Error('Audio unavailable');
      const active = context;
      buffer ??= options.loadAudio().then((data) => active.decodeAudioData(data)).catch((error: unknown) => { buffer = null; throw error; });
      const decoded = await buffer;
      if (disposed || active.state !== 'running') return;
      source?.stop();
      source = active.createBufferSource(); source.buffer = decoded;
      source.connect(active.destination); source.start();
    },
    dispose() {
      disposed = true; source?.stop();
      if (context && context.state !== 'closed') void context.close().catch(() => {});
    },
  };
}
